import { FileResult, ServiceResult } from '../models';
import { DocumentCategory, DocumentHeader } from '../models/documents.models';
import ApiService from './api-service';

class DocumentsService extends ApiService {
  private static classInstance: DocumentsService;

  private constructor() {
    super('Documents');
  }

  public getDocumentHeaders(documentCategoryId?: string): ServiceResult<DocumentHeader[]> {
    return this.get(`${this.baseUrl}/GetDocumentHeaders?documentCategoryId=${documentCategoryId}`);
  }

  public getDocumentHeadersSearch(): ServiceResult<DocumentHeader[]> {
    return this.get(`${this.baseUrl}/GetDocumentHeaders`);
  }

  public getDocumentCategories(parentCategoryId?: string): ServiceResult<DocumentCategory[]> {
    return this.get(`${this.baseUrl}/GetDocumentCategories?parentCategoryId=${parentCategoryId}`);
  }

  public getDocumentFile(documentDetailId: string): ServiceResult<FileResult> {
    return this.get(`${this.baseUrl}/GetDocumentFile?documentDetailId=${documentDetailId}`);
  }

  public static getInstance(): DocumentsService {
    if (!this.classInstance) {
      this.classInstance = new DocumentsService();
    }
    return this.classInstance;
  }
}

export default DocumentsService;
